import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '../stores/auth-store';

export function authGuard(to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) {
	const authStore = useAuthStore();

	if (to.meta.requiresLogin && !authStore.isAuthenticated) {
		next({ name: 'Login', query: to.query });
	} else if (to.name === 'Login' && authStore.isAuthenticated) {
		next({ name: 'Customers' });
	} else {
		next();
	}
}
